module.exports = __webpack_public_path__ + "static/media/myimage-1.96cd62b0.jpg";